import { useEffect, useState } from "react";
import ModalRondaMapaFiltros from "./ModalRondaMapaFiltros";
import dayjs from "dayjs";
import funcSleep from "../../../components/funcSleep";
import QrCodeRondaMapaPainelLateral from "./QrCodeRondaMapaPainelLateral";
import QrCodeRondaMapaPainelMapa from "./QrCodeRondaMapaPainelMapa";

export default function QrCodeRondaMapaRelatorioPage() {
    useEffect(() => {
        document.title = "Relatório Ronda Mapa | OB PORTUS";
        // eslint-disable-next-line
    }, []);

    const [loading, setLoading] = useState<boolean>(false);
    const [showModalConsultar, setShowModalConsultar] = useState<boolean>(true);
    const [registrosRonda, setRegistrosRonda] = useState<any[]>([]);
    const [filtroDados, setFiltroDados] = useState<any>({
        data_inicial: dayjs().format("YYYY-MM-DD"),
        data_final: dayjs().format("YYYY-MM-DD"),
        id_empresa: [],
        id_centro_custo: [],
        id_colaborador: [],
    });

    function handleChangeFiltros(dados: any, filtro_nome: string) {
        let filtro = filtroDados;
        if (filtro_nome === "inicial") {
            filtro.data_inicial = dados;
        }
        if (filtro_nome === "final") {
            filtro.data_final = dados;
        }
        if (filtro_nome === "empresa") {
            filtro.id_empresa = dados;
        }
        if (filtro_nome === "centro") {
            filtro.id_centro_custo = dados;
        }
        if (filtro_nome === "colaborador") {
            filtro.id_colaborador = dados;
        }
        setFiltroDados(filtro);
    }
    function handleChangeDatas(data_inicial: string, data_final: string) { 
        let filtro = filtroDados;
        filtro.data_inicial = data_inicial;
        filtro.data_final = data_final;
        setFiltroDados(filtro);
    }
    async function handleChangeRegistrosRonda(registros: any[]) {
        if (registros.length > 0) {
            setShowModalConsultar(false);
        }
        setLoading(true);
        await funcSleep(500);
        setRegistrosRonda(registros);
        setLoading(false);
    }

    return (
        <div id="main">
            <ModalRondaMapaFiltros show={showModalConsultar} handleClose={() => setShowModalConsultar(false)} handleChangeFiltros={handleChangeFiltros} filtroDados={filtroDados} handleChangeDatas={handleChangeDatas} handleChangeRegistros={(registros: any[]) => handleChangeRegistrosRonda(registros)} />
            <div className="div-row">
                <QrCodeRondaMapaPainelLateral registrosRonda={registrosRonda} filtroDados={filtroDados} setShowModalConsultar={(show:boolean) => setShowModalConsultar(show)} />

                <QrCodeRondaMapaPainelMapa registrosRonda={registrosRonda} loading={loading} />
            </div>
        </div>
    );
}
